export default {
  en: {
    title: 'My dictionaries',
    gridTitle: 'Personal',
    manageDictionaries: 'Manage dictionaries',
    newDictionary: 'New dictionary',
    createSubmit: 'Create',
    emptyState: "No dictionaries yet — create one and collect any words you like.",
  },
  ru: {
    title: 'Мои словари',
    gridTitle: 'Личные',
    manageDictionaries: 'Управление словарями',
    newDictionary: 'Новый словарь',
    createSubmit: 'Создать',
    emptyState: 'Словарей пока нет — заведи свой и собирай туда любые слова.',
  },
};
